import ProfileTabs from './ProfileTabs.component';

export default ProfileTabs;
